import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 4,
  class: "table-header__sortable-content"
}
const _hoisted_2 = { class: "table-header__text" }
const _hoisted_3 = {
  key: 5,
  class: "table-header__text"
}

import { i18n } from '@/i18n';
import TableHead from './TableHead.vue';
import ArrowIcon from './ArrowIcon.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import { TableContentProperty } from '../interface/tableContentHeaders';
import { BaseTableContentViewModel } from '../baseTableContentViewModel';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { HeaderList, TableType } from '@/coreDomainsModule/table';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTableHead',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    stableColumnCount: {},
    isEditing: { type: Boolean },
    isBold: { type: Boolean },
    isAllSelected: { type: Boolean },
    modifiableHeaderList: { default: () => [] as HeaderList },
    isOpenHeaderModifyButtonMenu: { type: Boolean },
    tableType: {}
  },
  emits: ["onClickSort", "onMousedownResizer", "onCheckboxSelected", "onToggleDisplayHeader", "onCheckboxSelectedBusinessId", "onToggleHeaderModifyButtonMenu"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const baseTableContentVM = new BaseTableContentViewModel();

// emits
const emits = __emit;

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableHead, {
    class: _normalizeClass([_unref(baseTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : '']),
    style: _normalizeStyle({
      left: _unref(baseTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth[_ctx.headerIndex]),
    }),
    index: _ctx.headerIndex,
    resizable: _ctx.header.isVariableWidth && !_unref(baseTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex),
    onOnMousedownResizer: _cache[5] || (_cache[5] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
  }, {
    default: _withCtx(() => [
      (_ctx.header.key === 'choice')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.tableType === 'firmOrderTable' || !_ctx.isEditing)
              ? (_openBlock(), _createBlock(RowCheckBox, {
                  key: 0,
                  "is-checked": _ctx.isAllSelected,
                  class: "md-primary all-check-button",
                  onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCheckboxSelected', '', true)))
                }, null, 8, ["is-checked"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.header.key === 'choiceBusinessId')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.isEditing)
              ? (_openBlock(), _createBlock(RowCheckBox, {
                  key: 0,
                  "is-checked": _ctx.isAllSelected,
                  class: "md-primary all-check-button",
                  onChangeStatus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onCheckboxSelectedBusinessId')))
                }, null, 8, ["is-checked"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.header.key === 'expansion')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(''))
            ], 64))
          : (_ctx.header.key === 'headerModify')
            ? (_openBlock(), _createBlock(TableHeaderModifyButton, {
                key: 3,
                "modifiable-header-list": _ctx.modifiableHeaderList,
                "is-open": _ctx.isOpenHeaderModifyButtonMenu,
                onToggle: _cache[2] || (_cache[2] = 
          (key, isHide) => {
            emits('onToggleDisplayHeader', key, isHide);
          }
        ),
                onToggleMenu: _cache[3] || (_cache[3] = 
          (isOpen) => {
            emits('onToggleHeaderModifyButtonMenu', isOpen);
          }
        )
              }, null, 8, ["modifiable-header-list", "is-open"]))
            : (_ctx.header.sortOption.isSortable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.header.displayLabel ?? _unref(t)(_ctx.header.key)), 1),
                  _createVNode(ArrowIcon, {
                    asc: _ctx.header.sortOption.isAsc,
                    onOnClick: _cache[4] || (_cache[4] = () => emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc))
                  }, null, 8, ["asc"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.header.displayLabel ?? _unref(t)(_ctx.header.key)), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "index", "resizable"]))
}
}

})